import { oldFontSizeMap } from '@/constants/options'
import { getDefaultUserSettings, type FontSize, type OldFontSize, type UserSettings } from './definition'
import { useUserLocalStorage } from '../user/users'
import { getBrowserLang } from '@/utils/util'
import { useLocalStorage } from '@vueuse/core'
import { computed, type Ref } from 'vue'
import { STORAGE_KEY_LANG, STORAGE_KEY_MENU_COLLAPSE, STORAGE_KEY_SETTINGS } from '@/constants'
import { tryUseNuxtApp } from '#app'

// Fix: Use a unique object instead of computed to prevent caching the result ref instance across requests in SSR.
// Use tryUseNuxtApp to guard useCookie calls so they don't fail when accessed outside Nuxt context (e.g. in beforeFetch hooks).
export const currentLang = {
  __v_isRef: true,
  get value() {
    const nuxtApp = tryUseNuxtApp()
    if (!nuxtApp) return getBrowserLang()
    // Only read, do not write default if missing to avoid SWR header errors
    const cookie = useCookie<string>(STORAGE_KEY_LANG, { readonly: true })
    return cookie.value || getBrowserLang()
  },
  set value(val) {
    const cookie = useCookie<string>(STORAGE_KEY_LANG)
    cookie.value = val
  }
} as unknown as Ref<string>

export function useUserSettings() {
  const settingsStorage = useUserLocalStorage<UserSettings>(STORAGE_KEY_SETTINGS, () => getDefaultUserSettings())

  // Backward compatibility, font size was xs, sm, md, lg, xl before
  if (settingsStorage.value.fontSize && !settingsStorage.value.fontSize.includes('px'))
    settingsStorage.value.fontSize = oldFontSizeMap[settingsStorage.value.fontSize as OldFontSize] as FontSize

  return settingsStorage
}

export const menuCollapse: Ref<boolean> = useLocalStorage<boolean>(STORAGE_KEY_MENU_COLLAPSE, isMd())

function isMd() {
  if (typeof window === 'undefined') return false
  const md = window.innerWidth >= 768
  console.log('md:', md)
  return md
}
